export const villaProjects = {
  ongoing: [
    {
      id: 'era-emerald',
      name: "Era Emerald",
      location: "Kudukkimotta, Kannur",
      status: "Ongoing",
      landArea: "2.13 Acres",
      units: "22 Villas",
      config: "4 BHK Premium Villas",
      price: "₹3,950/Sq.Ft",
      rera: "To be added",
      image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800",
      images: {
        exterior: [
          "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=1200&q=80",
          "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1200&q=80",
          "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&q=80",
          "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1200&q=80",
          "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=1200&q=80"
        ],
        interior: [
          "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=800&q=80",
          "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800&q=80",
          "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&q=80",
          "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&q=80",
          "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&q=80",
          "https://images.unsplash.com/photo-1600210492493-0946911123ea?w=800&q=80"
        ]
      },
      highlights: [
        "Prime residential location in Kannur",
        "22 Premium 4BHK Villas",
        "Gated community living",
        "Wide internal roads",
        "Proper drainage system",
        "Engineering-led construction"
      ],
      amenities: [
        { icon: "solar", title: "Solar-Powered Common Areas", desc: "Energy-efficient solar systems power common facilities, ensuring reduced electricity costs and a sustainable lifestyle." },
        { icon: "fitness", title: "Fitness Zone", desc: "Stay active and healthy with access to a dedicated fitness space designed for your daily workouts." },
        { icon: "lounge", title: "Community Lounge", desc: "A thoughtfully designed space where residents can relax, socialize, and celebrate special moments together." },
        { icon: "jogging", title: "Jogging & Walking Track", desc: "Enjoy refreshing morning walks or evening runs within a safe and serene environment." },
        { icon: "children", title: "Children's Play Area", desc: "A secure and engaging space for children to play, explore, and create lasting memories." },
        { icon: "recreation", title: "Family Recreation Park", desc: "Open green areas designed for families to unwind, relax, and spend quality time together." },
        { icon: "landscape", title: "Landscaped Green Zones", desc: "Beautifully designed landscapes with lush greenery enhance the overall living experience." },
        { icon: "gathering", title: "Outdoor Gathering Space", desc: "Dedicated open areas for hosting small events, celebrations, and community gatherings." },
        { icon: "pathway", title: "Wellness Walk Pathway", desc: "A specially designed pathway that promotes relaxation and well-being through mindful walking." },
        { icon: "parking", title: "Visitor Parking Area", desc: "Convenient parking spaces for guests, ensuring ease and comfort for visitors." },
        { icon: "security", title: "Entrance Security Cabin", desc: "A professionally managed security point at the entrance ensures controlled access to the community." },
        { icon: "cctv", title: "24/7 CCTV Surveillance", desc: "Advanced surveillance systems ensure safety and peace of mind for all residents." },
        { icon: "compound", title: "Compound Wall with Gated Access", desc: "A well-defined compound wall provides enhanced privacy and security." },
        { icon: "roads", title: "Internal Road Network", desc: "Well-planned and smoothly finished internal roads for easy and safe vehicle movement." },
        { icon: "lighting", title: "Common Area Lighting", desc: "Strategically placed lighting ensures visibility and safety throughout the community at night." },
        { icon: "ev", title: "EV Charging Provision", desc: "Provision for electric vehicle charging to support modern and eco-friendly mobility." },
        { icon: "library", title: "Reading Corner / Mini Library", desc: "A peaceful space dedicated to reading, relaxation, and quiet time." }
      ],
      locationAdvantages: [
        "Easy road access",
        "Close to schools and institutions",
        "Peaceful residential surroundings",
        "Good connectivity to main town"
      ],
      otherCharges: "GST, Stamp duty & registration charges, KSEB, KWA, Property tax & One Time Luxury Tax, One Time Association Deposit, KCWWC, Etc."
    }
  ],
  upcoming: [
    {
      id: 'era-sapphire',
      name: "Era Sapphire",
      location: "Calicut, Kerala",
      status: "Upcoming",
      landArea: "3 Acres",
      units: "30 Villas",
      config: "4 BHK Premium Villas",
      image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800",
      amenities: []
    }
  ]
};

export const commercialProjects = {
  ongoing: [
    {
      id: 'era-business-hub',
      name: "Era Business Hub",
      location: "Mavoor Road, Calicut",
      status: "Ongoing",
      landArea: "1.2 Acres",
      units: "48 Units",
      image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800",
    },
    {
      id: 'era-commercial-centre',
      name: "Era Commercial Centre",
      location: "Kuttikattoor, Calicut",
      status: "Ongoing",
      landArea: "0.8 Acres",
      units: "32 Units",
      image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800",
    }
  ],
  completed: [
    {
      id: 'era-plaza',
      name: "Era Plaza",
      location: "Feroke, Calicut",
      status: "Completed",
      landArea: "0.6 Acres",
      units: "24 Units",
      image: "https://images.unsplash.com/photo-1554435493-93422e8220c8?w=800",
    }
  ]
};

export const commercialGallery = {
  ongoing: [
    { id: 'cg-on-1', src: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80', location: 'Mavoor Road, Calicut', category: 'ongoing' },
    { id: 'cg-on-2', src: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80', location: 'Kuttikattoor, Calicut', category: 'ongoing' },
    { id: 'cg-on-3', src: 'https://images.unsplash.com/photo-1554435493-93422e8220c8?w=800&q=80', location: 'Mavoor Road, Calicut', category: 'ongoing' },
    { id: 'cg-on-4', src: 'https://images.unsplash.com/photo-1577495508048-b635879837f1?w=800&q=80', location: 'Calicut', category: 'ongoing' },
    { id: 'cg-on-5', src: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=800&q=80', location: 'Kuttikattoor, Calicut', category: 'ongoing' },
    { id: 'cg-on-6', src: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800&q=80', location: 'Calicut', category: 'ongoing' },
    { id: 'cg-on-7', src: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80', location: 'Mavoor Road', category: 'ongoing' },
  ],
  completed: [
    { id: 'cg-cp-1', src: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=800&q=80', location: 'Feroke, Calicut', category: 'completed' },
    { id: 'cg-cp-2', src: 'https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?w=800&q=80', location: 'Calicut', category: 'completed' },
    { id: 'cg-cp-3', src: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&q=80', location: 'Feroke', category: 'completed' },
    { id: 'cg-cp-4', src: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&q=80', location: 'Calicut', category: 'completed' },
    { id: 'cg-cp-5', src: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80', location: 'Kuttikattoor', category: 'completed' },
    { id: 'cg-cp-6', src: 'https://images.unsplash.com/photo-1590725140246-20acddc1ec6d?w=800&q=80', location: 'Calicut', category: 'completed' },
    { id: 'cg-cp-7', src: 'https://images.unsplash.com/photo-1565008447742-97f6f38c985c?w=800&q=80', location: 'Feroke', category: 'completed' },
  ],
};

export const teamMembers = [
  {
    name: "Majnaz V",
    role: "Civil Engineer",
    designation: "Managing Principal",
    image: "/teamMembers/Majnaz%20v.png"
  },
  {
    name: "P M Junaid",
    role: "Civil Engineer",
    designation: "Principal of Operations",
    image: "/teamMembers/P%20M%20Junaid.png"
  },
  {
    name: "Rafi",
    role: "Architect",
    designation: "Principal Designer",
    image: "/teamMembers/rafi.png"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Top 10 Vastu Tips for Your New Home",
    excerpt: "Discover ancient wisdom for modern living. Learn how Vastu principles can enhance positive energy in your home.",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800",
    category: "Design",
    date: "Feb 20, 2026"
  },
  {
    id: 2,
    title: "Why Gated Communities are the Future",
    excerpt: "Explore the benefits of community living with enhanced security, amenities, and lifestyle advantages.",
    image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800",
    category: "Lifestyle",
    date: "Feb 15, 2026"
  },
  {
    id: 3,
    title: "Understanding RERA: Your Rights as a Buyer",
    excerpt: "A comprehensive guide to RERA compliance and how it protects your real estate investment.",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800",
    category: "Legal",
    date: "Feb 10, 2026"
  }
];
